export default "__VITE_ASSET__aa619e79__"